import '@fontsource/inter/variable.css'

import { ChakraProvider } from '@chakra-ui/react'

import { Router } from './Router'
import { theme } from './theme'

export const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Router />
    </ChakraProvider>
  )
}
